


















import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { IToast } from '@/store/common/types';

const Common = namespace('common');

// 消息条
@Component
export default class Toast extends Vue {
  @Common.Mutation('setToast') public setToast!: (params: Partial<IToast>) => void;
  @Common.State('toast') public toast!: IToast;

  // 动画样式
  public get transition() {
    return this.toast.visible ? 'scroll-y-transition' : 'scroll-y-reverse-transition';
  }

  public onClose() {
    this.setToast({ visible: false });
  }
}
